// client/src/types/lexistar-tenant-settings.ts
//
// LexiStar tenant settings as GET / PATCH /api/lexistar/tenant-settings speak them
// (server/modules/lexistar/notifications: service.getTenantSettings → { settings, seeded };
// validation.patchTenantSettingsSchema). A lexistar.tenant_settings row (027), or the
// server's defaults while the tenant has none.

/**
 * Driver acknowledgement reminders (migration 034, ST-00206): 0 = none, 1 = the reminder
 * when TRIP.NOT_ACKNOWLEDGED fires only, 2 = also the last reminder when the alert escalates.
 */
export type AckRemindersLevel = 0 | 1 | 2;

export const ACK_REMINDER_LEVELS: readonly AckRemindersLevel[] = [0, 1, 2];

export interface LexiStarTenantSettings {
  tenant_id?: number;
  /** An unanswered deviation escalates after this (s). */
  deviation_decision_sla_s?: number;
  /** A dispatched trip not accepted by then raises TRIP.NOT_ACKNOWLEDGED (s). */
  ack_timeout_s?: number;
  auto_signoff_days?: number | null;
  review_threshold?: number;
  driver_default_language?: 'en' | 'af' | string;
  /** Absent from a server or database without migration 034. */
  ack_reminders?: AckRemindersLevel;
  updated_at?: string;
  updated_by?: string | null;
  version?: number;
}

/** PATCH /tenant-settings body (every field optional; at least one). */
export type LexiStarTenantSettingsPatch = Partial<
  Pick<
    LexiStarTenantSettings,
    | 'deviation_decision_sla_s'
    | 'ack_timeout_s'
    | 'auto_signoff_days'
    | 'review_threshold'
    | 'driver_default_language'
    | 'ack_reminders'
  >
>;
